import React from 'react';
import { FiDownload, FiFileText } from 'react-icons/fi';
import { useSolution } from '../../context/SolutionContext';
import { generatePDF, generateTextPDF } from '../../utils/pdfGenerator';
import Modal from '../ui/Modal';

const PDFExport = () => {
  const { state, dispatch } = useSolution();
  
  const handleExportVisual = async () => {
    const solutionData = {
      name: state.solutions.find(s => s.id === state.activeSolutionId)?.name || 'Untitled Solution',
      components: state.selectedComponents,
      createdAt: new Date().toISOString(),
      totalCost: state.totalCost
    };
    
    await generatePDF('dendrograph-container', 'ai-solution-visual.pdf');
    dispatch({ type: 'TOGGLE_EXPORT' });
  };
  
  const handleExportText = () => {
    const solutionData = {
      name: state.solutions.find(s => s.id === state.activeSolutionId)?.name || 'Untitled Solution',
      components: state.selectedComponents,
      createdAt: new Date().toISOString(),
      totalCost: state.totalCost
    };
    
    generateTextPDF(solutionData, 'ai-solution-report.pdf');
    dispatch({ type: 'TOGGLE_EXPORT' });
  };
  
  return (
    <Modal
      isOpen={state.uiState.showExportModal}
      onClose={() => dispatch({ type: 'TOGGLE_EXPORT' })}
      title="Export Solution"
      size="sm"
    >
      <div className="space-y-4">
        <p className="text-sm text-gray-600">
          Choose how you want to export your AI solution architecture
        </p>
        
        <button
          onClick={handleExportVisual}
          className="w-full p-4 border border-gray-200 rounded-xl hover:border-blue-400 hover:bg-blue-50 transition-colors flex items-center gap-4"
        >
          <FiFileText className="w-8 h-8 text-blue-500" />
          <div className="text-left">
            <h4 className="font-semibold text-gray-900">Visual PDF</h4>
            <p className="text-sm text-gray-500">Export the dendrograph visualization as PDF</p>
          </div>
        </button>
        
        <button
          onClick={handleExportText}
          className="w-full p-4 border border-gray-200 rounded-xl hover:border-green-400 hover:bg-green-50 transition-colors flex items-center gap-4"
        >
          <FiDownload className="w-8 h-8 text-green-500" />
          <div className="text-left">
            <h4 className="font-semibold text-gray-900">Text Report PDF</h4>
            <p className="text-sm text-gray-500">Export detailed component list and costs</p>
          </div>
        </button>
      </div>
    </Modal>
  );
};

export default PDFExport;